import React from 'react';
import { CompleteKundali, ChartStyle, PlanetPosition } from '../types/kundali';
import { NorthIndianSvgChart, SouthIndianSvgChart, EastIndianSvgChart, ChartLegend } from './ChartViewer';
import { ResponsiveChartContainer } from './ResponsiveChartContainer';

interface DashaChartViewProps {
  kundali: CompleteKundali;
  chartStyle: ChartStyle;
  lang: string;
  showDegrees: boolean;
  onSelectPlanet: (p: PlanetPosition) => void;
  onSelectHouse: (h: number) => void;
}

export const DashaChartView: React.FC<DashaChartViewProps> = ({
  kundali,
  chartStyle,
  lang,
  showDegrees,
  onSelectPlanet,
  onSelectHouse
}) => {
  // Find current MD
  const md = kundali.dashas.find(d => d.isCurrent);
  
  // We'll show the D1 chart, but maybe we can do something else if needed
  const chartData = kundali.charts.D1;

  return (
    <div className="space-y-4">
      <h3 className="font-bold text-astro-primary font-serif text-lg">
        Dasha-Based Chart ({md ? md.planet : 'N/A'})
      </h3>
      <ResponsiveChartContainer maxDimension={650} minDimension={220} className="w-full mx-auto">
        {() => (
          <>
            {chartStyle === 'north' && (
              <NorthIndianSvgChart
                chartData={chartData}
                planets={chartData.planets}
                ashtakvarga={kundali.ashtakvarga}
                onSelectHouse={onSelectHouse}
                onSelectPlanet={onSelectPlanet}
                lang={lang as any}
                showDegrees={showDegrees}
              />
            )}
            {chartStyle === 'south' && (
              <SouthIndianSvgChart
                chartData={chartData}
                planets={chartData.planets}
                ashtakvarga={kundali.ashtakvarga}
                onSelectHouse={onSelectHouse}
                onSelectPlanet={onSelectPlanet}
                lang={lang as any}
                showDegrees={showDegrees}
              />
            )}
            {chartStyle === 'east' && (
              <EastIndianSvgChart
                chartData={chartData}
                planets={chartData.planets}
                ashtakvarga={kundali.ashtakvarga}
                onSelectHouse={onSelectHouse}
                onSelectPlanet={onSelectPlanet}
                lang={lang as any}
                showDegrees={showDegrees}
              />
            )}
          </>
        )}
      </ResponsiveChartContainer>
      <div className="max-w-md mx-auto">
        <ChartLegend lang={lang as any} />
      </div>
    </div>
  );
};

